import React from "react";

interface VideoSkeletonLoaderProps {
  className?: string;
  style?: React.CSSProperties;
}

const baseStyle: React.CSSProperties = {
  minHeight: "350px",
};

const VideoSkeletonLoader: React.FC<VideoSkeletonLoaderProps> = ({
  className = "w-100 h-100 rounded-4",
  style,
}) => (
  <div
    className={`${className} position-relative placeholder-glow overflow-hidden`}
    style={{ ...baseStyle, ...style }}
    aria-hidden="true"
  >
    <span
      className="placeholder w-100 d-block rounded-4"
      style={{ ...baseStyle, ...style, backgroundColor: "#e9ecef" }}
    />
    <div
      className="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center gap-2"
      style={{ zIndex: 1 }}
    >
      <div
        className="rounded-circle d-flex align-items-center justify-content-center placeholder"
        style={{ width: "56px", height: "56px", backgroundColor: "#dee2e6" }}
      >
        <i
          className="fa-solid fa-play text-secondary"
          style={{ fontSize: "20px", marginLeft: "3px" }}
        />
      </div>
      <span
        className="placeholder col-6 rounded-pill"
        style={{ height: "12px", maxWidth: "120px" }}
      />
    </div>
  </div>
);

export default VideoSkeletonLoader;
